import dayjs from 'dayjs'

export const formatAgreementDates = (startDate: Date, endDate: Date) => {
  const format = dayjs(startDate).year() === dayjs(endDate).year() ? 'D MMM' : 'D MMM YYYY'
  return `${dayjs(startDate).format(format)} - ${dayjs(endDate).format('D MMM YYYY')}`
}
